/**
 *
 * @module index
 * @author Adam Pirani [adam.pirani@mlb.com]
 * @description build entry point / g5-component reference
 *
 */

import G5Component from 'g5-component';

import { inject as base } from 'g5-component/src/scripts/dependencies/defaultInjector';

import extender from './component/extender';
import helpers from './component/helpers';
import component from './component/master';
import partials from './component/partials';

import eventGroupExtender from './events/group/extender';
import Model from './model/master';
import ViewModel from './viewModel/master';
import template from './../template/component.html';

class FedComponentMlbScores extends G5Component {

    constructor(opts) {
        const implementation = base({});

        implementation.extender = extender;
        implementation.helpers = helpers;
        implementation.component = component;
        implementation.partials = partials;

        implementation.template = template;
        implementation.eventGroupExtender = eventGroupExtender;
        implementation.Model = Model;
        implementation.ViewModel = ViewModel;

        super(opts, implementation);

    }

}

export default function factory(opts) {

    return new FedComponentMlbScores(opts);

}
